import { validationMessages, yup } from '@medely/ui-kit';

export const personalValidationSchema = yup.object({
  nickname: yup.string().nullable(),
  phone_number: yup.string().phone().required(validationMessages.phone.required),
  address_first: yup.string().required('Required'),
  address_second: yup.string().nullable(),
  address_city: yup.string().required('Required'),
  state_id: yup.number().required('Required'),
  address_zip: yup
    .mixed<number | string>()
    .required(validationMessages.zip.required)
    .test('zip5', validationMessages.zip.length, (value) => {
      if (!value) {
        return false;
      }
      const digits = String(value).replace(/\D/g, '');
      const padded = digits.padStart(5, '0');
      return /^\d{5}$/.test(padded);
    }),
  emergency_first_name: yup.string().required('Required'),
  emergency_last_name: yup.string().required('Required'),
  emergency_phone_number: yup.string().phone().required('Required'),
});
